module.exports = __webpack_public_path__ + "img/bg.5897d745.jpg";